module.exports = __webpack_public_path__ + "img/lighting.67af2d09.png";